// extracted by mini-css-extract-plugin
export default {"rating":"iz-z","numberOfStars":"jz-z","count":"kz-z","barGraphSpacing":"lz-z","barGraph":"mz-z"};